import {
  MediaData,
  NumberMediaData,
  FillInTheBlankNodeData,
  FillInTheBlanksData,
} from '../../../types/quiz';
import { getQuestion, parseKeyTakeaways, parseMainExp } from './utils';

/**
 * MapFillInTheBlank.
 */
export const mapFillInTheBlank = ({
  data,
  mediaData,
}: {
  data: FillInTheBlankNodeData;
  mediaData: MediaData<NumberMediaData[]>;
}): FillInTheBlanksData => {
  const image = data.image
    ? `${process.env.NEXT_PUBLIC_S3_BUCKET_URL}/${data.image}`
    : '';
  return {
    question: getQuestion<NumberMediaData[]>(data.q, mediaData),
    answer: data.a,
    image,
    units: data.u || '',
    keyTakeaway: parseMainExp(data.kp, mediaData) || '',
    keyTakeaways: data.kps ? parseKeyTakeaways(data.kps, mediaData) : [],
  };
};
